import { parseToString } from './parseNumbers'

const selectPhoneMask = (value, mask) => {
  const onlyNumbers = parseToString(value)
  return onlyNumbers.length > 10 ? mask.landLinePhone : mask.phone
}

export default selectPhoneMask
